import moment from 'moment';
import { unitOfTime } from 'moment';

import { TimeInput } from '@/interfaces/timeInput';

moment.locale('pl');

/**
 * Zwraca cyfry z dodanym zerem na początku
 *
 * @export
 * @param {number} i
 * @returns {string}
 */
export function toClock(i: number): string {
  return (i < 10 ? '0' : '') + i;
}

/**
 * Zwraca pierwszy i ostatni dzień dla danego widoku kalendarza
 *
 * @export
 * @param {string} view
 * @param {number} queryYear
 * @param {number} queryMonth
 * @param {number} queryDay
 * @returns
 */
export function getTimePeriod(view: string, queryYear: number, queryMonth: number, queryDay: number) {
  const queryDate = moment()
    .year(queryYear)
    .month(queryMonth - 1)
    .date(queryDay);
  const start = queryDate.startOf(view as unitOfTime.StartOf).toDate();
  const end = queryDate.endOf(view as unitOfTime.StartOf).toDate();

  return { start, end };
}

/**
 * Zwraca dzisiejszy rok, miesiąc, dzień, godzinę, minutę oraz sekundę
 *
 * @export
 * @returns
 */
export function getToday() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const hour = today.getHours();
  const minute = today.getMinutes();
  const second = today.getSeconds();

  return { year: today.getFullYear(), month, day, hour, minute, second };
}

/**
 * Zwraca sekundy jako TimeInput
 *
 * @export
 * @param {number} seconds
 * @returns {TimeInput}
 */
export function secondsToTimeInput(seconds: number): TimeInput {
  const timeModel = { hour: 0, minute: 0, second: 0, hundredth: 0 };

  timeModel.hour = Math.floor(seconds / 3600);
  timeModel.minute = Math.floor(seconds / 60) - timeModel.hour * 60;
  timeModel.second = Math.floor(seconds % 60);
  timeModel.hundredth = seconds * 100 - (timeModel.hour * 3600 + timeModel.minute * 60 + timeModel.second) * 100;

  return timeModel;
}
